<template>
  <history-item-template
    :createTime="action.createTime"
    :creatorName="action.creatorName"
    :comment="action.data.comment"
    :vbAttachments="action.attachments"
    @downloadFile="({vbAttachment}) => $emit('downloadFile', {vbAttachment})"
  >
    <template #historyHeader>
      <p
        :class="['action-type flex-row flex__left inline-flex', 'color__blue']"
      >
        <i :class="['font-size__small', 'fal fa-check-circle']"></i>
        <span class="font-size__small no_wrap">
          &nbsp;{{ "Ban hành văn bản đến" }}
        </span>
      </p>
      <!--build thong tin người nhận-->
      {{ receiverNames }}

      <el-popover
        placement="top-start"
        trigger="click"
        title="Danh sách: "
        transition="el-zoom-in-bottom"
      >
        <el-table
          :data="banHanhInfo"
          style="width: 100%"
          stripe
          max-height="400"
          :show-header="false"
          size="mini"
        >
          <el-table-column type="index" width="40"></el-table-column>
          <el-table-column
            label="Đơn vị/Cá nhân"
            width="400"
            show-overflow-tooltip
          >
            <template slot-scope="scope">
              <span
                class="padding-0 margin-0"
                v-if="
                  scope.row.type === 'donVi' ||
                    scope.row.type === 'donViTrenTruc' ||
                    scope.row.type === 'donViBenNgoai'
                "
              >
                <span class="font-weight__bold font-size__medium">
                  {{ getReceiverName(scope.row) }}
                </span>
              </span>
              <span
                class="padding-0 margin-0"
                v-if="scope.row.type === 'caNhan'"
              >
                <span class="font-weight__bold font-size__medium">
                  {{ scope.row.handler.fullName }}
                </span>
                <br/>
                <span class="font-weight__regular font-size__small">
                  ({{ scope.row.handler.positionName }} --
                  {{ scope.row.handler.deptName }})
                </span>
              </span>
            </template>
          </el-table-column>
          <el-table-column label="''" width="120" show-overflow-tooltip>
            <template slot-scope="scope">
              <span class="padding-0 margin-0">
                <span class="font-weight__bold font-size__medium">
                  {{ getProcessTypeLabel(scope.row) }}
                </span>
              </span>
            </template>
          </el-table-column>
        </el-table>
        <span slot="reference">
          <i class="fas fa-info-circle color__yellow"></i>
        </span>
      </el-popover>
      <!--build thong tin người nhận:end-->
    </template>
  </history-item-template>
</template>

<script>
  import convertToLabelFilter from "../../filters/convertToLabelFilter";
  import PopoverWord2 from "../common/popover-word-2";
  import h from "../../services/h";
  import constants from "../../constants";
  import HistoryItemTemplate from "../common/layout/history-item-template";

  export default {
    name: "ban-hanh-toi-history-item",
    components: {HistoryItemTemplate, PopoverWord2},
    props: ["action"],
    filters: {
      convertToLabelFilter
    },
    data() {
      return {
        departments: [],
        vbOutgoingDoc: null,
        handlers: null,
        receiverDepts: null,
        receiverHandlers: null,
        tltvbAgencies: null,
        outsideDepartments: null,
        banHanhInfo: [],
        receiverNames: null
      };
    },
    created() {
      this.action && this.initData();
    },
    methods: {
      getReceiverName(banHanhInfoItem) {
        let type = banHanhInfoItem.type;
        switch (type) {
          case "donVi":
            return banHanhInfoItem.department.deptName;
          case "donViBenNgoai":
            return banHanhInfoItem.outsideDepartment;
          case "caNhan":
            return `${banHanhInfoItem.handler.fullName} (${banHanhInfoItem.handler.positionName} - ${banHanhInfoItem.handler.deptName})`;
          case "donViTrenTruc":
            return `${banHanhInfoItem.agency.name} (${banHanhInfoItem.agency.code} - ${banHanhInfoItem.agency.mail})`;
          default:
            return "";
        }
      },

      getShortReceiverName(banHanhInfoItem) {
        let type = banHanhInfoItem.type;
        switch (type) {
          case "donVi":
            return banHanhInfoItem.department.deptName;
          case "donViBenNgoai":
            return banHanhInfoItem.outsideDepartment;
          case "caNhan":
            return banHanhInfoItem.handler.fullName;
          case "donViTrenTruc":
            return banHanhInfoItem.agency.name;
          default:
            return "";
        }
      },

      getProcessTypeLabel(banHanhInfoItem) {
        let type = banHanhInfoItem.type;
        switch (type) {
          case "donViTrenTruc":
          case "donViBenNgoai":
            return "-";
          default:
            let processType = banHanhInfoItem.receiverForm.processType;
            switch (processType) {
              case constants.PROCESS_TYPE.CHUTRI:
                return "Chủ trì";
              case constants.PROCESS_TYPE.NHANDEBIET:
                return "Nhận để biết";
              case constants.PROCESS_TYPE.PHOIHOP:
                return "Phối hợp";
              default:
                return "-";
            }
        }
      },

      initData() {
        let dataJson = this.action.dataJson;
        this.vbOutgoingDoc = dataJson.vbOutgoingDoc;
        this.handlers = dataJson.handlers;
        this.receiverDepts = dataJson.receiverDepts;
        this.receiverHandlers = dataJson.receiverHandlers;
        this.departments = dataJson.departments;
        this.tltvbAgencies = dataJson.tltvbAgencies;
        this.outsideDepartments = dataJson.outsideDepartments;
        let version = dataJson.version;
        switch (version) {
          case 1:
            this.populateBanHanhInfoV1();
            break;
          default:
            this.populateBanHanhInfoV0();
        }
        let banHanhInfo = this.banHanhInfo;
        let sentence = "";
        if (banHanhInfo && banHanhInfo.length) {
          let banHanhInfoFirstItem = banHanhInfo[0];
          sentence =
            banHanhInfo.length === 1
              ? this.getShortReceiverName(banHanhInfoFirstItem)
              : `${this.getShortReceiverName(
              banHanhInfoFirstItem
              )} và ${banHanhInfo.length - 1} đơn vị khác`;
        }
        this.receiverNames = sentence;
      },

      /**
       * hien thi vs du lieu cu;
       */
      populateBanHanhInfoV0() {
        h.each(this.departments, department => {
          let receiverForm = {id: department.id, processType: null};
          this.banHanhInfo.push({
            type: "donVi",
            receiverForm: receiverForm,
            department: department
          });
        });
      },

      populateBanHanhInfoV1() {
        this.banHanhInfo = [];
        h.each(this.receiverHandlers, receiverForm => {
          let handler = h.find(
            this.handlers,
            handler => handler.id === receiverForm.id
          );
          receiverForm &&
          handler &&
          this.banHanhInfo.push({
            type: "caNhan",
            receiverForm: receiverForm,
            handler: handler
          });
        });
        h.each(this.receiverDepts, receiverForm => {
          let department = h.find(
            this.departments,
            department_ => department_.id === receiverForm.id
          );
          receiverForm &&
          department &&
          this.banHanhInfo.push({
            type: "donVi",
            receiverForm: receiverForm,
            department: department
          });
        });
        h.each(this.tltvbAgencies, agency => {
          this.banHanhInfo.push({
            type: "donViTrenTruc",
            agency: agency
          });
        });
        h.each(this.outsideDepartments, outsideDepartment => {
          this.banHanhInfo.push({
            type: "donViBenNgoai",
            outsideDepartment: outsideDepartment
          });
        });
      }
    }
  };
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/views/doc-in/ban-hanh-toi-history-item.vue